module.exports = __webpack_public_path__ + "static/details-6-1e079b295bffc3af616adf9c66f5dc87.jpg";